import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pathfinder-website/pathfinder-website/app/sdk/components/SdkSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pathfinder-website/pathfinder-website/node_modules/next/dist/client/app-dir/link.js");
